import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";
import { useCacheOperations } from "@/composables/cache";

const { info: logInfo } = useLogger("HOUSINGS_XREF_RESOLVER");

export default {
  queries: {
    scenario_equipment_xref_housings: {
      housing: (parent, args, cache, info) => {
        return parent.housing_id
          ? { __typename: "housings", id: parent.housing_id }
          : null;
      }
    }
  },
  optimistic: {
    insert_revisions_scenario_equipment_xref_housings_revisions(
      vars,
      cache,
      info
    ) {
      logInfo("Optimistic", { vars, cache, info });
      return {
        __typename:
          "revisions_scenario_equipment_xref_housings_revisions_mutation_response",
        returning: vars.objects.map(object => ({
          id: object.id,
          __typename: "revisions_scenario_equipment_xref_housings_revisions",
          scenario_equipment_xref_housings_view: {
            __typename: "scenario_equipment_xref_housings",
            housing: null,
            ...object,
            ...revisionDefaultFields(object)
          }
        }))
      };
    }
  },
  updates: {
    insert_revisions_scenario_equipment_xref_housings_revisions(
      result,
      args,
      cache,
      info
    ) {
      logInfo("Mutation", { result, args, cache, info });

      args.objects.forEach(object => {
        const { handleCacheUpdate } = useCacheOperations({
          cache,
          object,
          typename: "scenario_equipment_xref_housings"
        });

        handleCacheUpdate([
          {
            args: {
              where: {
                journal_deleted_at: {
                  _is_null: true
                }
              }
            },
            relatedCacheKey: cache.keyOfEntity({
              __typename: "scenario_equipment_xref_pumps",
              id: object.scenario_equipment_xref_pump_id
            }),
            relatedField: "xref_housings"
          }
        ]);
      });
    }
  }
} as ModelsResolver;
